/**
 * A folder of a repository that is a project of its own (§5.4) — `site`,
 * `apps/web` — and the one rule everything that stores one agrees on: the app's
 * store, the project document's parser, and the account area's editor.
 *
 * It is joined onto a clone's path and handed to `cd` in a guest (§3.2), so
 * the rule is about what a path join and a shell would read differently:
 * relative, `/`-separated, never a step out of the repository, and none of the
 * characters a shell treats specially. Empty is the repository itself.
 */
export const MAX_SUB_PATH_CHARS = 200;

// eslint-disable-next-line no-control-regex -- control characters are exactly what is refused.
const UNSAFE = /[\\:*?"<>|'$`\x00-\x1f]/;

export function validSubPath(subPath: string): boolean {
  if (!subPath) return true;
  if (subPath.length > MAX_SUB_PATH_CHARS || subPath.startsWith('/') || subPath.endsWith('/')) return false;
  return subPath.split('/').every((segment) => segment && segment !== '.' && segment !== '..' && !UNSAFE.test(segment));
}
